// Названия разделов каталога («Стебли»/«Букеты» переименовываются владельцем,
// например в «Сеты») — серверный источник GET /settings → catalog_label_*.
// Кэш на сессию: все компоненты видят одинаковые значения без лишних запросов.
// Аналог витринного src/catalogLabels.js.
import { useEffect, useState } from 'react';
import { api } from './api';

const fallback = {
  products: 'Стебли',
  bouquets: 'Букеты',
  subscription: 'Подписка',
};

let cache = null;
let pending = null;

function fetchCatalogLabels() {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = api.getSettings()
      .then((s) => {
        cache = {
          products: s.catalog_label_products || fallback.products,
          bouquets: s.catalog_label_bouquets || fallback.bouquets,
          subscription: s.catalog_label_subscription || fallback.subscription,
        };
        return cache;
      })
      .catch(() => fallback);
  }
  return pending;
}

export function useCatalogLabels() {
  const [labels, setLabels] = useState(cache || fallback);
  useEffect(() => {
    let alive = true;
    fetchCatalogLabels().then((l) => { if (alive) setLabels(l); });
    return () => { alive = false; };
  }, []);
  return labels;
}

// Единственное число, нижний регистр («букет», «сет») — для бейджей и
// текстов вида «Состав на 1 сет». Неизвестное слово → нижний регистр как есть.
const SINGULAR = {
  'букеты': 'букет',
  'сеты': 'сет',
  'наборы': 'набор',
  'боксы': 'бокс',
  'комплекты': 'комплект',
  'композиции': 'композиция',
  'охапки': 'охапка',
  'корзины': 'корзина',
  'моно-букеты': 'моно-букет',
  'монобукеты': 'монобукет',
  'стебли': 'стебель',
  'цветы': 'цветок',
};

export function singularLower(label) {
  const low = (label || '').trim().toLowerCase();
  return SINGULAR[low] || low;
}

export function capitalizeFirst(s) {
  return s ? s[0].toUpperCase() + s.slice(1) : s;
}
